import en from './en'
import cn from './cn'
import fr from './fr'
export default {
  en,
  cn,
  fr,
}
